<div class="sensor-cable-table">
    <div class="buttons-container">
        <!-- <input
            type="file"
            class="excelFile"
            (change)="selectedFileChange($event)"
            #excelFileInput
        /> -->
        <div class="button-wrapper row-buttons" [class.disabled]="isTableEmpty" (click)="printSensorCableTable()">
            {{ 'channel.print' | translate }}
        </div>

        <!-- <div
            class="button-wrapper row-buttons"
            (click)="importButtonClick()"
            [class.disabled]="isImportButtonDisabled()"
        >
            <mat-icon svgIcon="import"></mat-icon>
            <span>{{ "channel.import" | translate }}</span>
        </div>
        <div
            class="button-wrapper row-buttons"
            [class.disabled]="isTableEmpty()"
            (click)="downloadButtonClick()"
        >
            <mat-icon svgIcon="export"></mat-icon>
            <span>{{ "channel.export" | translate }}</span>
        </div> -->
    </div>

    <div
        style="display: flex; flex: 1; overflow: hidden"
        [ngStyle]="{ maxWidth: tableWidth ? tableWidth : 'unset' }"
        #spreadsheetContainer>
        <div #spreadsheet></div>
    </div>

    <ng-container *ngIf="textColorIsOpen">
        <app-excel-color-picker
            style="position: absolute; top: 100px; left: 430px"
            [selectedColor]="textColor"
            (onColorSelected)="updateTextColor($event)"
            (onClosePicker)="textColorIsOpen = false">
        </app-excel-color-picker>
    </ng-container>

    <ng-container *ngIf="fillColorIsOpen">
        <app-excel-color-picker
            style="position: absolute; top: 100px; left: 475px"
            [selectedColor]="fillColor"
            (onColorSelected)="updateCellColor($event)"
            (onClosePicker)="fillColorIsOpen = false">
        </app-excel-color-picker>
    </ng-container>

    <ng-container *ngIf="helpIsOpen && !isOutputSlot() && !isDORelaySlot()">
        <div class="help-container">
            {{ 'sensor-cable-tag.help.main' | translate }}
            <span class="semibold">{{ 'sensor-cable-tag.help.item-name' | translate }}</span>
            <ng-container *ngIf="isDISlot() || isDONormalSlot()">.</ng-container>
            <ng-container *ngIf="isAISlot() || isThermalK()"
                >,
                <span class="semibold">{{ 'sensor-cable-tag.help.range' | translate }}</span>
                and
                <span class="semibold">{{ 'sensor-cable-tag.help.unit' | translate }}</span
                >.
            </ng-container>
        </div>
    </ng-container>

    <ng-container *ngIf="tableHasErrors()">
        <div
            #errorsContainer
            class="error-icon-wrapper"
            [ngStyle]="{
                right: errorIconRight ? errorIconRight : 'unset',
                left: errorIconLeft ? errorIconLeft : 'unset',
            }"
            (click)="showErrors = !showErrors; $event.stopPropagation()">
            <mat-icon svgIcon="save-error" class="error-icon" />
            <div class="errors-list" *ngIf="showErrors">
                <div *ngFor="let error of getTableErrors()" class="error-message">
                    <ng-container *ngIf="error.error == ERROR_OVER_4">
                        {{ 'sensor-cable-tag.error.limit-over' | translate: { value: 4 } }}
                        <span class="semibold">{{ error.columnName }}</span
                        ><span *ngIf="!error.columnName.endsWith('.')">.</span>
                    </ng-container>
                    <ng-container *ngIf="error.error == ERROR_OVER_7">
                        {{ 'sensor-cable-tag.error.limit-over' | translate: { value: 7 } }}
                        <span class="semibold">{{ error.columnName }}</span
                        ><span *ngIf="!error.columnName.endsWith('.')">.</span>
                    </ng-container>
                    <ng-container *ngIf="error.error == ERROR_OVER_10">
                        {{ 'sensor-cable-tag.error.limit-over' | translate: { value: 10 } }}
                        <span class="semibold">{{ error.columnName }}</span
                        ><span *ngIf="!error.columnName.endsWith('.')">.</span>
                    </ng-container>
                    <ng-container *ngIf="error.error == ERROR_OVER_40">
                        {{ 'sensor-cable-tag.error.limit-over' | translate: { value: 40 } }}
                        <span class="semibold">{{ error.columnName }}</span
                        ><span *ngIf="!error.columnName.endsWith('.')">.</span>
                    </ng-container>
                    <ng-container *ngIf="error.error == ERROR_INVALID">
                        {{ 'sensor-cable-tag.error.invalid.1' | translate }}
                        <span class="semibold">{{ error.columnName }}</span
                        ><span *ngIf="!error.columnName.endsWith('.')">.</span>
                        <br />
                        <br />
                        {{ 'sensor-cable-tag.error.invalid.2' | translate }}
                    </ng-container>
                    <ng-container *ngIf="error.error == ERROR_INVALID_NOCORE">
                        {{ 'sensor-cable-tag.error.invalid.1' | translate }}
                        <span class="semibold">{{ error.columnName }}</span
                        ><span *ngIf="!error.columnName.endsWith('.')">.</span>
                        <br />
                        <br />
                        {{ 'sensor-cable-tag.error.invalid.3' | translate }}
                    </ng-container>
                </div>
            </div>
        </div>
    </ng-container>
</div>

<ng-container *ngIf="isLoading">
    <div class="loading-container">
        <app-loading-spinner [custom]="true" class="spinner-component" size="80" strokeWidth="3"></app-loading-spinner>
    </div>
</ng-container>
